import React, { useEffect, useState, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import { RootState } from '../../redux/store';
import { GetWelcomeListPagingAndFilterResponse, GetWelcomeListPagingAndFilterResponseData, GetWelcomeListPagingAndFilterResponseItem, initialGetWelcomeListPagingAndFilterResponseData } from '../../models/response/welcome/GetWelcomeListPagingAndFilterResponse';
import { GetWelcomeListPagingAndFilterRequest, initialGetWelcomeListPagingAndFilterRequest } from '../../models/request/welcome/GetWelcomeListPagingAndFilterRequest';
import { CustomSingleSelectModel } from '../CustomSingleSelect';
import { ColumnChooserModel } from '../../models/common/ColumnChooserModel';
import { kolonlariBirlestir } from '../ColumnFilter/kolonBirlestir';
import { MenuComponent } from '../../_metronic/assets/ts/components';
import { storeActivityIndicator, storeAreYouSureModalCallback } from '../../redux/reducers/authSlice';
import { DeleteWelcomeResponse } from '../../models/response/welcome/DeleteWelcomeResponse';
import { WelcomeService } from '../../services/WelcomeService';
import Content from '../../_metronic/layout/components/content/Content';
import { KTCard } from '../../_metronic/helpers/components/KTCard';
import { KTIcon } from '../../_metronic/helpers/components/KTIcon';
import { Helpers } from '../../helpers/Helpers';
import { KTCardBody } from '../../_metronic/helpers/components/KTCardBody';
import TableFooter from '../TableFooter';
import { WelcomeStatusEnum } from '../../models/common/Enums';
import { GetConstantListResponse } from '../../models/response/constant/GetConstantListResponse';
import { ConstantService } from '../../services/ConstantService';
import { ExportWelcomeListResponse } from '../../models/response/welcome/ExportWelcomeListResponse';
import { ToolbarWrapper } from '../../_metronic/layout/components/toolbar';
import RefreshButton from '../../components/RefreshButton';
import { PageTitle } from '../../_metronic/layout/core';
import { ChangeWelcomeStatusResponse } from '../../models/response/welcome/ChangeWelcomeStatusResponse';
import CommonWelcomeListFilters from './Components/CommonWelcomeListFilters';
import { useSortableColumns } from '../../helpers/useSortableColumns';
import ColumnFilterRow from '../ColumnFilter/ColumnFilterRow';
import ColumnFilterChips from '../ColumnFilter/ColumnFilterChips';
import { ColumnFilterDefinitions } from '../ColumnFilter/ColumnFilterTypes';
import { loadConstants, loadList } from '../ColumnFilter/columnFilterOptions';
import { ColumnFilterModel } from '../../models/common/ColumnFilterModel';
import StatusBadge from '../StatusBadge';
import { CompanyService } from '../../services/CompanyService';
import { DriverService } from '../../services/DriverService';
import { buildExcelRequest, ExcelExportMode } from '../../helpers/excelExportRequest';

// Açılışta İşlem Durumu kolon filtresinde seçili gelen durumlar (eski filtre panelindeki varsayılan).
const DEFAULT_WELCOME_STATUSES: string[] = [WelcomeStatusEnum.SIPARIS_GELECEK, WelcomeStatusEnum.ARAC_GELDI, WelcomeStatusEnum.ARAC_SAHAYA_ALINSIN, WelcomeStatusEnum.ARAC_SAHAYA_ALINDI, WelcomeStatusEnum.ARAC_KANTARA_GIRDI];

interface Props {
    pageName: string
    isIn: boolean
    isOut: boolean
}

const CommonWelcomeList = ({
    pageName,
    isIn,
    isOut
}: Props) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const auth = useSelector((state: RootState) => state.auth)
    const pageVersion = "1";
    const [data, setData] = useState<GetWelcomeListPagingAndFilterResponseData>(initialGetWelcomeListPagingAndFilterResponseData);
    const [filter, setFilter] = useState<GetWelcomeListPagingAndFilterRequest>(initialGetWelcomeListPagingAndFilterRequest);
    const [defaultWelcomeCompanyType, setDefaultWelcomeCompanyType] = useState<CustomSingleSelectModel | undefined>(undefined);

    const getColumns = () => {
        var list: ColumnChooserModel[] = [];

        var str = localStorage.getItem(pageName + "-" + pageVersion + "-filters");

        list = [
            { title: 'Ref No', name: 'refNo', order: 0, isVisible: true },
            { title: 'Müşteri', name: 'customerName', order: 0, isVisible: true },
            { title: 'Tedarikçi', name: 'supplierName', order: 0, isVisible: true },
            { title: 'Araç Plaka', name: 'vehicleName', order: 0, isVisible: true },
            { title: 'Dorse Plaka', name: 'trailerName', order: 0, isVisible: true },
            { title: 'Konteyner No', name: 'containerNo', order: 0, isVisible: true },
            { title: 'Sürücü', name: 'driverName', order: 0, isVisible: true },
            { title: 'Araç Kayıt Tarihi', name: 'vehicleArriveDateStr', order: 0, isVisible: true },
            { title: 'İşlem Durumu', name: 'welcomeStatusName', order: 0, isVisible: true },
            { title: 'Bağlı Teklif Ref No', name: 'antrepoOfferRefNo', order: 0, isVisible: true },
            { title: 'Oluşturan', name: 'createdUser', order: 0, isVisible: true },
            { title: 'Güncelleyen', name: 'updatedUser', order: 0, isVisible: true }
        ];

        for (var i = 0; i < list.length; i++) {
            list[i].order = i + 1;
        }

        return kolonlariBirlestir(list, str);
    }

    const [columns, setColumns] = useState<ColumnChooserModel[]>(getColumns());

    const performPagination = (i: number) => {
        getData({
            ...filter,
            currentPage: i,
            skip: (i - 1) * filter.take
        });
    }

    const changeTake = (_take: number) => {
        getData({
            ...filter,
            currentPage: 1,
            skip: 0,
            take: _take
        });
    }

    useEffect(() => {
        setTimeout(() => { MenuComponent.reinitialization() }, 1000)

        getFirstData();
    }, [])

    // Açılışta İşlem Durumu kolon filtresine varsayılan durumlar konur, liste onunla gelir.
    // Durum listesi alınamazsa liste filtresiz açılır.
    const getFirstData = async () => {
        var columnFilters: ColumnFilterModel[] = [];

        try {
            dispatch(storeActivityIndicator(true))

            var response: GetConstantListResponse = await ConstantService.getConstantList('WELCOME_STATUS');

            if (!response.isSuccess)
                toast.error(response.message)
            else {
                var defaults = response.data.filter(x => x.additionalValue1 && DEFAULT_WELCOME_STATUSES.includes(x.additionalValue1));

                if (defaults.length > 0)
                    columnFilters = [{
                        column: 'welcomeStatusName',
                        values: defaults.map(x => x.constantId),
                        valueLabels: defaults.map(x => x.value + '')
                    }];
            }
        } catch (error: any) {
            toast.error(error)
        }

        getData({ ...filter, columnFilters: columnFilters });
    }

    const deleteWelcome = async () => {
        try {
            var selectedIds = data.items.filter(x => x.isSelected).map(x => x.welcomeId);

            dispatch(storeActivityIndicator(true))

            var response: DeleteWelcomeResponse = await WelcomeService.deleteWelcome(selectedIds);

            if (!response.isSuccess) {
                toast.error(response.message)
                dispatch(storeActivityIndicator(false))
                return;
            }

            toast.success(response.message)

            getData();
        } catch (error: any) {
            toast.error(error)
            dispatch(storeActivityIndicator(false))
        }
    }

    const changeWelcomeStatus = async (_welcomeStatusId: string) => {
        try {
            var selectedIds = data.items.filter(x => x.isSelected).map(x => x.welcomeId);

            dispatch(storeActivityIndicator(true))

            var response: GetConstantListResponse = await ConstantService.getConstantList('WELCOME_STATUS', undefined, _welcomeStatusId);

            if (!response.isSuccess) {
                toast.error(response.message)
                dispatch(storeActivityIndicator(false))
                return;
            }

            var response2: ChangeWelcomeStatusResponse = await WelcomeService.changeWelcomeStatus(selectedIds, response.data[0].constantId);

            if (!response2.isSuccess) {
                toast.error(response2.message)
                dispatch(storeActivityIndicator(false))
                return;
            }

            toast.success(response2.message)

            getData();
        } catch (error: any) {
            toast.error(error)
            dispatch(storeActivityIndicator(false))
        }
    }

    const updateWelcome = async (_id: string | undefined = undefined) => {
        navigate((isIn ? '/welcomein/listadd?id=' : isOut ? '/welcomeout/listadd?id=' : '') + (_id ? _id : data.items.filter(x => x.isSelected)[0].welcomeId));
    }

    // Kolon filtresinde art arda istek gidebilir; yalnızca en son isteğin cevabı ekrana yazılır.
    const lastRequestNo = useRef(0);

    const getData = async (_filter: GetWelcomeListPagingAndFilterRequest | undefined = undefined) => {
        const requestNo = ++lastRequestNo.current;

        try {
            if (_filter)
                setFilter(_filter);
            else
                _filter = filter;

            dispatch(storeActivityIndicator(true))

            var response: GetWelcomeListPagingAndFilterResponse = await WelcomeService.getWelcomeListPagingAndFilter({
                ..._filter,
                isIn: isIn,
                isOut: isOut
            });

            if (requestNo != lastRequestNo.current)
                return;

            if (!response.isSuccess) {
                toast.error(response.message)
                return;
            }

            setData(response.data);
        } catch (error: any) {
            toast.error(error)
        }
        finally {
            // Daha yeni bir istek sürüyorsa yükleniyor göstergesi açık kalır.
            if (requestNo == lastRequestNo.current)
                dispatch(storeActivityIndicator(false))
        }
    }

    const setItemSelected = (_id: string) => {
        setData({
            ...data,
            items: data.items.map(function (x) {
                if (x.welcomeId == _id)
                    x.isSelected = !x.isSelected;
                return x;
            })
        })
    }

    const selectAll = () => {
        var isAllSelected = data.items.filter(x => x.companyId && (!x.ledgerNo || x.ledgerNo == '-')).length == data.items.filter(x => x.companyId && (!x.ledgerNo || x.ledgerNo == '-') && x.isSelected).length;

        setData({
            ...data,
            items: data.items.map(function (x) {
                if (x.companyId && (!x.ledgerNo || x.ledgerNo == '-'))
                    x.isSelected = !isAllSelected;

                return x;
            })
        })
    }

    const onSearchSubmit = (e: any) => {
        e.preventDefault()
        getData();
    }

    const excelExport = async (mode: ExcelExportMode) => {
        try {
            dispatch(storeActivityIndicator(true))

            var response: ExportWelcomeListResponse = await WelcomeService.exportWelcomeList(buildExcelRequest({ ...filter, isIn: isIn, isOut: isOut }, mode, data.items.filter(x => x.isSelected).map(x => x.welcomeId), columns));

            if (!response.isSuccess) {
                toast.error(response.message)
                return;
            }

            window.location.href = Helpers.getEndpoint() + "/Excels/" + response.data;
        } catch (error: any) {
            toast.error(error)
        }
        finally {
            dispatch(storeActivityIndicator(false))
        }
    }

    // Başlığa tıklayarak sıralanabilen kolonlar. Veritabanında gerçek karşılığı
    // olmayan kolonlar listeye alınmadı.
    const sortableColumns = [
        'refNo', 'customerName', 'supplierName', 'vehicleName',
        'trailerName', 'containerNo', 'driverName', 'vehicleArriveDateStr',
        'welcomeStatusName', 'antrepoOfferRefNo', 'createdUser', 'updatedUser'
    ];

    const { thProps, sortArrow } = useSortableColumns(sortableColumns, filter, getData);

    // Kolon başlıklarının altındaki filtreler. Kolon adları backend'deki eşlemeyle
    // (WelcomeManager.ApplyColumnFilters) aynı.
    const columnFilterDefinitions: ColumnFilterDefinitions = {
        refNo: { type: 'text' },
        customerName: { type: 'select', loadOptions: () => loadList(CompanyService.getCompanyList({ isCustomer: true }), 'companyId', x => x.name) },
        supplierName: { type: 'select', loadOptions: () => loadList(CompanyService.getCompanyList({ isSupplier: true }), 'companyId', x => x.name) },
        vehicleName: { type: 'text' },
        trailerName: { type: 'text' },
        containerNo: { type: 'text' },
        driverName: { type: 'select', loadOptions: () => loadList(DriverService.getDriverList(), 'driverId', x => x.nameSurname) },
        vehicleArriveDateStr: { type: 'date' },
        welcomeStatusName: { type: 'select', loadOptions: () => loadConstants('WELCOME_STATUS'), renderOption: (label) => <StatusBadge text={label} /> },
        antrepoOfferRefNo: { type: 'text' },
        createdUser: { type: 'text' },
        updatedUser: { type: 'text' },
    };

    // Kolon filtresi değişince ilk sayfaya dönülür; sıralama ve sayfa boyu korunur.
    const changeColumnFilters = (columnFilters: ColumnFilterModel[]) => {
        getData({ ...filter, columnFilters: columnFilters, currentPage: 1, skip: 0 });
    }

    const getColumnValue = (item: GetWelcomeListPagingAndFilterResponseItem, column: string, index: number, className: string | undefined) => {
        if (column == "refNo") {
            return (
                <td
                    className={className}
                    onClick={(!item.companyId || !(!item.ledgerNo || item.ledgerNo == '-')) ? undefined : () => setItemSelected(item.welcomeId)}
                    onDoubleClick={(!item.companyId || !(!item.ledgerNo || item.ledgerNo == '-')) ? undefined : () => updateWelcome(item.welcomeId)}>
                    <a onClick={() => window.open(window.location.href + "add?id=" + item.welcomeId, "_blank")} href='javascript:;'>{item.refNo}</a>
                </td>
            )
        }
        else if (column == "welcomeStatusName") {
            return (
                <td
                    className={className}
                    onClick={(!item.companyId || !(!item.ledgerNo || item.ledgerNo == '-')) ? undefined : () => setItemSelected(item.welcomeId)}
                    onDoubleClick={(!item.companyId || !(!item.ledgerNo || item.ledgerNo == '-')) ? undefined : () => updateWelcome(item.welcomeId)}>
                    <StatusBadge text={item.welcomeStatusName} />
                </td>
            )
        }
        else if (column == "createdUser") {
            return (
                <td
                    className={className}
                    onClick={(!item.companyId || !(!item.ledgerNo || item.ledgerNo == '-')) ? undefined : () => setItemSelected(item.welcomeId)}
                    onDoubleClick={(!item.companyId || !(!item.ledgerNo || item.ledgerNo == '-')) ? undefined : () => updateWelcome(item.welcomeId)}>
                    {item.createdUser} - {item.createdDate}
                </td>
            )
        }
        else if (column == "updatedUser") {
            return (
                <td
                    className={className}
                    onClick={(!item.companyId || !(!item.ledgerNo || item.ledgerNo == '-')) ? undefined : () => setItemSelected(item.welcomeId)}
                    onDoubleClick={(!item.companyId || !(!item.ledgerNo || item.ledgerNo == '-')) ? undefined : () => updateWelcome(item.welcomeId)}>
                    {item.updatedUser} - {item.updatedDate}
                </td>
            )
        }
        else {
            var item2: any = item;
            return (
                <td
                    className={className}
                    onClick={(!item.companyId || !(!item.ledgerNo || item.ledgerNo == '-')) ? undefined : () => setItemSelected(item.welcomeId)}
                    onDoubleClick={(!item.companyId || !(!item.ledgerNo || item.ledgerNo == '-')) ? undefined : () => updateWelcome(item.welcomeId)}>
                    {item2[column]}
                </td>
            );
        }
    }

    return (
        <React.Fragment>
            <ToolbarWrapper filters={<React.Fragment>
                <RefreshButton onClick={() => getData()} />
                <CommonWelcomeListFilters
                    columns={columns}
                    excelExport={excelExport}
                    getColumns={getColumns}
                    pageName={pageName}
                    pageVersion={pageVersion}
                    setColumns={setColumns}
                    changeWelcomeStatus={changeWelcomeStatus}
                    selectedCount={data.items.filter(x => x.isSelected).length}
                    filter={filter}
                    getData={getData}
                    setFilter={setFilter}
                    isIn={isIn}
                    isOut={isOut}
                    items={data.items}
                    deleteFunction={deleteWelcome}
                    updateFunction={() => updateWelcome()}
                    onSearchSubmit={onSearchSubmit}
                />
            </React.Fragment>} />

            <PageTitle breadcrumbs={[{
                title: pageName.split('>').slice(0, pageName.split('>').length - 1).join(' > ') + ' > ',
                isActive: false,
                path: ''
            }]}>{(pageName.split('>')[pageName.split('>').length - 1])}</PageTitle>

            <Content>
                <KTCard className='mb-3'>
                    <KTCardBody className='py-2'>
                        <ColumnFilterChips
                            columns={columns}
                            definitions={columnFilterDefinitions}
                            filters={filter.columnFilters}
                            onChange={changeColumnFilters}
                        />

                        <div className='table-responsive new-table-container'>
                            <table id='kt_table_users' className='table align-middle table-row-dashed dataTable no-footer ebbe-compact-table'>
                                <thead>
                                    <tr className='text-start text-muted fw-bolder text-uppercase'>
                                        <th style={{ width: 1 }}>
                                            <div className='d-flex'>
                                                <label className='form-check form-check-sm form-check-custom form-check-solid me-5'>
                                                    <input onChange={selectAll} className='form-check-input' type='checkbox' checked={data.items.filter(x => x.isSelected).length > 0 && data.items.filter(x => x.isSelected).length == data.items.filter(x => x.companyId && (!x.ledgerNo || x.ledgerNo == '-')).length} />
                                                </label>
                                            </div>
                                        </th>

                                        {
                                            columns.filter(x => x.isVisible).sort(function (a, b) { return a.order - b.order; }).map((item, index) =>
                                                <th {...thProps(item.name)}>
                                                    {item.title}
                                                    {sortArrow(item.name)}
                                                </th>
                                            )
                                        }
                                    </tr>

                                    <ColumnFilterRow
                                        columns={columns.filter(x => x.isVisible).sort(function (a, b) { return a.order - b.order; })}
                                        definitions={columnFilterDefinitions}
                                        filters={filter.columnFilters}
                                        onChange={changeColumnFilters}
                                        leadingCellCount={1}
                                    />
                                </thead>
                                <tbody className='text-gray-600 fw-bold'>
                                    {
                                        data.items.length == 0 && (
                                            <tr>
                                                <td className="text-center" colSpan={99}>Kayıt bulunamadı.</td>
                                            </tr>
                                        )
                                    }
                                    {
                                        data.items.map((item, index) =>
                                            <tr style={{ background: item.isSelected ? 'rgba(204, 204, 204, 0.25)' : undefined }}>
                                                <td style={{ width: 1 }}>
                                                    {
                                                        (item.companyId && (!item.ledgerNo || item.ledgerNo == "-")) && (
                                                            <div className='d-flex'>
                                                                <label className='form-check form-check-sm form-check-custom form-check-solid me-5'>
                                                                    <input onChange={() => setItemSelected(item.welcomeId)} className='form-check-input' type='checkbox' checked={item.isSelected} />
                                                                </label>
                                                            </div>
                                                        )
                                                    }
                                                </td>

                                                {
                                                    columns.filter(x => x.isVisible).sort(function (a, b) { return a.order - b.order }).map((column, columnIndex) => (
                                                        <React.Fragment>{getColumnValue(item, column.name, index, column.className)}</React.Fragment>
                                                    ))
                                                }
                                            </tr>
                                        )
                                    }
                                </tbody>
                            </table>
                        </div>
                    </KTCardBody>

                    <TableFooter
                        changeTake={changeTake}
                        take={filter.take}
                        currentPage={filter.currentPage}
                        performPagination={performPagination}
                        totalPageCount={Math.ceil(data.totalRecordCount / filter.take)}
                        totalRecordCount={data.totalRecordCount}
                        selectedCount={data.items.filter(x => x.isSelected).length}
                    />
                </KTCard>
            </Content>
        </React.Fragment>
    )
}

export default CommonWelcomeList;